import React from 'react';
import { FiX } from 'react-icons/fi';
import styles from './AttendanceCorrectionModal.module.css';

function AttendanceCorrectionModal({
  isOpen,
  title = 'Request attendance correction',
  sessionTitle,
  sessionDateLabel,
  currentStatus,
  requestedStatus,
  reason,
  onReasonChange,
  submitting = false,
  onClose,
  onSubmit,
}) {
  if (!isOpen) return null;

  return (
    <div
      className={styles.overlay}
      onClick={() => {
        if (!submitting) onClose?.();
      }}
    >
      <div className={styles.modal} onClick={(event) => event.stopPropagation()}>
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            disabled={submitting}
            aria-label="Close"
          >
            <FiX size={18} />
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.sessionInfo}>
            <div className={styles.sessionName}>{sessionTitle}</div>
            <div className={styles.sessionDate}>{sessionDateLabel}</div>
          </div>

          <div className={styles.changeRow}>
            <span className={styles.changeLabel}>Change status from</span>
            <span className={styles.changeFrom}>{currentStatus}</span>
            <span className={styles.changeArrow}>→</span>
            <span className={styles.changeTo}>{requestedStatus}</span>
          </div>

          <label className={styles.reasonLabel} htmlFor="attendanceCorrectionReason">
            Reason (optional)
          </label>
          <textarea
            id="attendanceCorrectionReason"
            className={styles.reasonInput}
            value={reason}
            onChange={(event) => onReasonChange?.(event.target.value)}
            placeholder="Add any details that will help us review your request…"
            rows={3}
            maxLength={500}
            disabled={submitting}
          />
        </div>

        <div className={styles.footer}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.submitButton}
            onClick={onSubmit}
            disabled={submitting}
          >
            {submitting ? 'Submitting…' : 'Submit request'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AttendanceCorrectionModal;
